(function(algolia) {
  'use strict';

  if (!algolia || !algolia.config) return;

  // Legacy generated config isn't refreshed by the v5 dashboard toggle, so
  // keep storefront-specific settings in a theme-owned override.
  algolia.config.collection_css_selector = '#main_content_area';
  algolia.config.search_client_version = 5;
  algolia.config.instant_search_enabled_on_collection = false;

  // Ensure 'tags' facet is enabled for search filtering (Kosher/Organic filters)
  if (Array.isArray(algolia.config.facets)) {
    var tagsFacet = algolia.config.facets.find(function(facet) {
      return facet.name === 'tags';
    });
    if (tagsFacet) {
      tagsFacet.enabled = true;
    } else {
      algolia.config.facets.push({
        enabled: true,
        name: 'tags',
        title: 'Tags',
        type: 'conjunctive',
        available_types: ['menu', 'conjunctive', 'disjunctive'],
        forgettable: null,
        searchable: false,
        refined_first: false,
      });
    }
  }
})(window.algoliaShopify);
